module.exports = __webpack_public_path__ + "static/media/academico.378b3baf.png";